import { Resource } from './resource';
import { FileUpload } from './fileUpload';
import { Applicant } from './applicant';

export class ApplicantDocument extends Resource {

    applicant: String;
    file: String;
}